export default {
  status: {
    archived: '#00b8d8',
    closed: '#17c671 ',
    in_execution: '#8e24aa',
    terminated: 'red',
    during: '#007bff',
    not_accepted: 'black',
    draft: '#919191',
    not_paid_on_time: '#ffff00',
  },
};
